import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-bag-payment-list-table-summary',
	templateUrl: './bag-payment-list-table-summary.component.html',
	styleUrls: ['./bag-payment-list-table-summary.component.scss'],
})
export class BagPaymentListTableSummaryComponent implements OnChanges {
	@ViewChild('dataTable') table: MatTable<any>;
	@Input() data;
	@Input() tableColumns = [];
	matData = new MatTableDataSource<any>();
	protected tableKeys: string[];
	constructor() {}

	ngOnChanges(): void {
		if (!this.data) {
			return;
		}
		this.loadData();
	}

	protected loadData(): void {
		this.matData.data = this.data;
		this.convertData(this.matData.data);
	}

	protected convertData(data) {
		this.tableKeys = this.tableColumns.map((col) => col.id);
		this.matData.data = data;
	}
}
